import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { LeadGenerationSourceComponent } from '../../module/front/firm-pages/sweet-spot-manage/lead-generation-source/lead-generation-source.component';
import { CurrentCarrierHistoryComponent } from '../../module/front/firm-pages/sweet-spot-manage/current-carrier-history/current-carrier-history.component';

@Injectable({
  providedIn: 'root',
})
export class ApiUrlHelper {
  public apiUrl = {
    baseUrl: {
      baseApiUrl: environment.apiUrl,
    },
    admin: {
      login: 'account/admin-login',
      dashboard: 'admin/AddressMaster/get-admin-dashboard-data',
      submitPotentialMatch: 'admin/PotentialMatch/submit-potential-match'
    },
    // account: {
    //   login: 'account/login',
    //   changePassword: 'account/change-password',
    //   forgotPassword: 'account/forgot-password',
    //   verifyOTP: 'account/verify-otp',
    //   resetPassword: 'account/reset-password',
    // },
    account: {
      login: 'common/user/login',
      changePassword: 'common/user/change-password',
      forgotPassword: 'common/user/forgot-password',
      verifyOTP: 'common/user/verify-otp',
      resetPassword: 'common/user/reset-password',
      changeEmail: 'common/user/change-email',
      sentOTPToUser: 'common/user/send-otp-change-email',
      verifyChangeEmailOTP: 'common/user/verify-otp-change-email',
      resendOTPChangeEmail: 'common/user/resend-OTP/{Email}',
      savePreferLanguage: 'common/user/save-prefer-language',
      getPreferLanguage: 'common/user/get-prefer-language'
    },
    carRegistrationTypeMaster: {
      getCarRegistrationTypeList: 'admin/carRegistrationTypeMaster/list',
      getCarRegistrationTypeById:
        'admin/carRegistrationTypeMaster/GetById?carRegistrationTypeId={carRegistrationTypeId}',
      addUpdateCarRegistrationType: 'admin/carRegistrationTypeMaster/save',
      deleteCarRegistrationType:
        'admin/carRegistrationTypeMaster/delete/{carRegistrationTypeId}',
    },
    incidentTypes: {
      incidentTypesList: 'admin/IncidentType/list',
      incidentTypeById:
        'admin/IncidentType/IncidentType?incidentTypeId={incidentTypeId}',
      incidentTypeAddUpdate: 'admin/IncidentType/save',
      incidentTypeDelete: 'admin/IncidentType/delete',
      exportIncidentTypes: 'admin/IncidentType/ExportIncidentTypes',
      downloadIncidentTypeSampleFile: 'admin/IncidentType/DownloadSampleFile',
      importIncidentTypes: 'admin/IncidentType/ImportIncidentTypes',
    },
    maritalStatus: {
      maritalStatusById:
        'admin/MaritalStatus/MaritalStatus?maritalStatusId={statusId}',
      maritalStatusAddUpdate: 'admin/MaritalStatus/save',
      maritalStatusList: 'admin/MaritalStatus/list',
      maritalStatusDelete: 'admin/MaritalStatus/delete',
    },
    violationTicket: {
      violationTicketById:
        'admin/ViolationTicket/ViolationTicket?violationTicketId={violationTicketId}',
      violationTicketAddUpdate: 'admin/ViolationTicket/save',
      violationTicketList: 'admin/ViolationTicket/list',
      violationTicketDelete:
        'admin/ViolationTicket/delete?violationTicketId={violationTicketId}&userId={userId}',
      violationTicketCategoryList: 'admin/ViolationTicket/category-list',
    },
    bannerManagement: {
      bannerDetailsList: 'admin/BannerManagement/list',
      bannerDetailsAddUpdate: 'admin/BannerManagement/save',
    },
    creditScoreTypeMaster: {
      getCreditScoreTypeMasterList: 'admin/creditScoreTypeMaster/list',
      getCreditScoreTypeMasterById:
        'admin/creditScoreTypeMaster/GetById?creditScoreTypeId={creditScoreTypeId}',
      addUpdateCreditScoreTypeMaster: 'admin/creditScoreTypeMaster/save',
      deleteCreditScoreType:
        'admin/creditScoreTypeMaster/delete/{creditScoreTypeId}',
      exportCreditScoreTypes:
        'admin/creditScoreTypeMaster/ExportCreditScoreTypes',
      ImportCreditScoreType: 'admin/creditScoreTypeMaster/upload',
    },
    houseType: {
      getHouseTypes: 'admin/houseType/list',
      getHouseTypeById: 'houseType/getHouseType?id={id}',
      addUpdateHouseType: 'admin/houseType/AddUpdateHouseType',
      deleteHouseType: 'admin/houseType/DeleteHouseType/{houseTypeId}',
      exportHouseTypes: 'admin/houseType/ExportHouseTypes',
      downloadHouseTypeSampleFile:
        'admin/houseType/DownloadHouseTypeSampleFile',
      importHouseType: 'admin/houseType/upload',
    },
    personalInjuryProtection: {
      getPersonalInjuryProtectionList:
        'admin/PersonalInjuryProtectionMaster/list',
      getPersonalInjuryProtectionById:
        'admin/PersonalInjuryProtectionMaster/GetById?PersonalInjuryProtectionId={PersonalInjuryProtectionId}',
      addUpdatePersonalInjuryProtectionMaster:
        'admin/PersonalInjuryProtectionMaster/save',
      deletePersonalInjuryProtection:
        'admin/PersonalInjuryProtectionMaster/delete/{personalInjuryProtectionId}',
      getStateDropDownList: 'admin/PersonalInjuryProtectionMaster/StateDDlist',
    },
    prefixMaster: {
      getPrefixList: 'admin/prefix/list',
      savePrefix: 'admin/prefix/save-prefix',
      deletePrefix: 'admin/prefix/delete',
      exportPrefix: 'admin/prefix/export',
      importPrefix: 'admin/prefix/import',
    },
    vehicle: {
      getVehicleMakeDDLList: 'admin/vehicle/make-ddl-list',
      getVehicleModelDDLList: 'admin/vehicle/model-ddl-list',
      getVehicleSubModelDDLList: 'admin/vehicle/sub-model-ddl-list',
      saveVehicleMake: 'admin/vehicle/save-vehicle-make',
      saveVehicleModel: 'admin/vehicle/save-vehicle-model',
      saveVehicleSubModel: 'admin/vehicle/save-vehicle-submodel',
      getVehicleMakeById: 'admin/vehicle/make-by-id/{vehiclemakeid}',
      getVehicleModelById: 'admin/vehicle/model-by-id/{vehiclemodelid}',
      getVehicleSubModelById:
        'admin/vehicle/submodel-by-id/{vehiclesubmodelid}',
      deleteVehicleMake: 'admin/vehicle/delete-vehicle-make/{VehicleMakeId}',
      deleteVehicleModel: 'admin/vehicle/delete-vehicle-model/{VehicleModelId}',
      deleteVehicleSubModel:
        'admin/vehicle/delete-vehicle-submodel/{VehicleSubModelId}',
      getVehicleMakeList: 'admin/vehicle/make-list',
      getVehicleModelList: 'admin/vehicle/model-list',
      getVehicleSubModelList: 'admin/vehicle/sub-model-list',
      exportVehicleMake: 'admin/vehicle/export-vehicle-make',
      exportVehicleModel: 'admin/vehicle/export-vehicle-model',
      exportVehicleSubModel: 'admin/vehicle/export-vehicle-submodel',
      ImportVehicleMake: 'admin/vehicle/upload',
      getVehicleById: 'admin/vehicle/vehicle-by-id/{vehicleId}',
    },
    employeementStatusMaster: {
      employeementStatusMasterList: 'admin/employeementStatus/List',
      employeementStatusMasterById: 'admin/employeementStatus/GetById',
      employeementStatusMasterAddUpdate: 'admin/employeementStatus/AddUpdate',
      employeementStatusMasterDelete: 'admin/employeementStatus/Delete',
      exportEmployeementStatus: 'admin/employeementStatus/Export',
      downloadSampleFile: 'admin/employeementStatus/DownloadSampleFile',
      importEmployeementStatus: 'admin/employeementStatus/upload',
    },
    residentType: {
      getResidentTypeList: 'admin/resident/GetAllResidentType',
      getResidentTypeById:
        'admin/resident/GetResidentTypeById?residentTypeId={residentTypeId}',
      addUpdateResidentType: 'admin/resident/AddEditResidentType',
      deleteResidentType: 'admin/resident/DeleteResidentType/{ResidentTypeId}',
      downloadSampleFile: 'admin/resident/DownloadSampleFile',
      exportResidentTypes: 'admin/resident/ExportResidentTypes',
      ImportResidentType: 'admin/resident/upload',
    },
    language: {
      getLanguageList: 'admin/Language/List',
      addUpdateLanguage: 'admin/Language/AddUpdate',
      deleteLanguage: 'admin/Language/Delete',
      exportLanguage: 'admin/Language/ExportLanguage',
      importLanguage: 'admin/language/upload',
    },
    insuranceCarriers: {
      getInsuranceCarriersList: 'admin/InsuranceCarriers/List',
      addUpdateInsuranceCarrier: 'admin/InsuranceCarriers/AddUpdate',
      deleteInsuranceCarrier: 'admin/InsuranceCarriers/Delete',
      deleteResidentType:
        'admin/resident/DeleteResidentType/{ResidentTypeId}?UserId={UserId}',
      downloadSampleFile: 'admin/resident/DownloadSampleFile',
      exportInsuranceCarrier: 'admin/InsuranceCarriers/ExportInsuranceCarriers',
      importInsuranceCarrier: 'admin/InsuranceCarriers/upload',
    },
    faqMaster: {
      getFAQList: 'admin/Faq/List',
      addUpdateFAQ: 'admin/Faq/AddUpdate',
      deleteFAQ: 'admin/Faq/Delete',
    },

    educationMaster: {
      getEducationList: 'admin/education/list',
      saveEducation: 'admin/education/save-education',
      ActiveInactive: 'admin/education/active-inactive',
      deleteEducation: 'admin/education/delete',
      exportEducation: 'admin/education/export',
      importEducation: 'admin/education/import',
    },
    coverageCategoryMaster: {
      coverageCategoryMasterList: 'admin/coverageCategory/List',
      coverageCategoryMasterById: 'admin/coverageCategory/GetById',
      coverageCategoryMasterAddUpdate: 'admin/coverageCategory/AddUpdate',
      coverageCategoryMasterDelete: 'admin/coverageCategory/Delete',
      exportCoverageCategory: 'admin/coverageCategory/Export',
      downloadSampleFile: 'admin/coverageCategory/DownloadSampleFile',
      importCoverageCategory: 'admin/coverageCategory/upload',
    },
    aditionalPersonalInjuryProtection: {
      getAdditionalPersonalInjuryProtectionList:
        'admin/AdditionalPersonalInjuryProtectionMaster/list',
      getAdditionalPersonalInjuryProtectionById:
        'admin/AdditionalPersonalInjuryProtectionMaster/GetById?AdditionalPersonalInjuryProtectionId={AdditionalPersonalInjuryProtectionId}',
      addUpdateAdditionalPersonalInjuryProtectionMaster:
        'admin/AdditionalPersonalInjuryProtectionMaster/save',
      deleteAdditionalPersonalInjuryProtection:
        'admin/AdditionalPersonalInjuryProtectionMaster/delete/{additionalPersonalInjuryProtectionId}',
    },
    rentalCarReimbursement: {
      getRentalCarReimbursementMasterList:
        'admin/RentalCarReimbursementMaster/list',
      geRentalCarReimbursementById:
        'admin/RentalCarReimbursementMaster/GetById?RentalCarReimbursementId={RentalCarReimbursementId}',
      addUpdateRentalCarReimbursementMaster:
        'admin/RentalCarReimbursementMaster/save',
      deleteRentalCarReimbursement:
        'admin/RentalCarReimbursementMaster/delete/{rentalCarReimbursementId}',
    },
    suffix: {
      getSuffixList: 'admin/suffix/list',
      saveSuffix: 'admin/suffix/saveSuffix',
      deleteSuffix: 'admin/suffix/deleteSuffix/{suffixId}',
      exportSuffix: 'admin/suffix/ExportSuffix',
      downloadSampleFile: 'admin/suffix/DownloadSampleFile',
      importSuffix: 'admin/suffix/ImportSuffix',
    },
    partnerBusinessType: {
      getPartnerBusinessTypeList: 'admin/partnerBusinessType/list',
      savePartnerBusinessType: 'admin/partnerBusinessType/save',
      deletePartnerBusinessType: 'admin/partnerBusinessType/delete/{businessTypeId}',
    },
    firmTypeMaster: {
      getFirmTypeMasterList: 'admin/firm-type-master/list',
      saveFirmTypeMaster: 'admin/firm-type-master/save',
      deleteFirmTypeMaster: 'admin/firm-type-master/delete/{firmTypeId}',
    },
    partnerRole: {
      getPartnerRoleList: 'admin/partnerRole/list',
      savePartnerRole: 'admin/partnerRole/save',
      deletePartnerRole: 'admin/partnerRole/delete/{roleId}',
    },
    coverage: {
      getCoverageList: 'admin/Coverage/List',
      addUpdateCoverage: 'admin/Coverage/AddUpdate',
      deleteCoverage: 'admin/Coverage/Delete',
      getCoverageValueRange: 'admin/Coverage/GetCoverageRangeList',
      getMinMaxForDoubleDropDown: 'admin/Coverage/Get-Minmax-DoubleDropdown',
    },
    comprehensivewithFullGlassDeductible: {
      getComprehensiveFullGlassDeductibleList:
        'admin/ComprehensiveFullGlassDeductibleMaster/list',
      getComprehensiveFullGlassDeductibleById:
        'admin/ComprehensiveFullGlassDeductibleMaster/GetById?ComprehensiveFullGlassDeductibleId={ComprehensiveFullGlassDeductibleId}',
      addUpdateComprehensiveFullGlassDeductibleMaster:
        'admin/ComprehensiveFullGlassDeductibleMaster/save',
      deleteComprehensiveFullGlassDeductible:
        'admin/ComprehensiveFullGlassDeductibleMaster/delete/{comprehensiveFullGlassDeductibleId}',
    },
    optionalBasicEconomicLossMaster: {
      getOptionalBasicEconomicLossList:
        'admin/OptionalBasicEconomicLossMaster/list',
      getOptionalBasicEconomicLossId:
        'admin/OptionalBasicEconomicLossMaster/GetById?OptionalBasicEconomicLossId={OptionalBasicEconomicLossId}',
      addUpdateOptionalBasicEconomicLossMaster:
        'admin/OptionalBasicEconomicLossMaster/save',
      deleteOptionalBasicEconomicLossMaster:
        'admin/OptionalBasicEconomicLossMaster/delete/{optionalBasicEconomicLossId}',
    },
    vehiclePrimaryUseMaster: {
      getVehiclePrimaryUse: 'admin/vehicle-primary-use/list',
      saveVehiclePrimaryUse:
        'admin/vehicle-primary-use/save-vehicle-primary-use',
      deleteVehiclePrimaryUse: 'admin/vehicle-primary-use/delete',
      exportVehiclePrimaryUse: 'admin/vehicle-primary-use/export',
      importVehiclePrimaryUse: 'admin/vehicle-primary-use/import',
    },
    relationshipMaster: {
      getRelationshipList: 'admin/relation/list',
      saveRelationship: 'admin/relation/save-relationship',
      deleteRelationship: 'admin/relation/delete',
      exportRelationship: 'admin/relation/export',
      importRelationship: 'admin/relation/import',
    },
    stateWiseCoverage: {
      getStateWiseCovergaeList: 'admin/stateWiseCoverage/StateWiseCoverageList',
      getStateWiseCoverageById: 'admin/stateWiseCoverage/GetById',
      addUpdatestateWiseCoverage: 'admin/stateWiseCoverage/AddUpdate',
      deleteStateWiseCoverage: 'admin/stateWiseCoverage/Delete',
      getOwnershipTypeList: 'admin/stateWiseCoverage/OwnershipList',
      getCoveragesByCategory:
        'admin/stateWiseCoverage/get-coverage-by-category/{categoryId}',
      getCoverageValues:
        'admin/stateWiseCoverage/get-coverage-value/{coverageId}',
      saveStatewiseCoverage:
        'admin/stateWiseCoverage/AddUpdateStateWiseCoverages',
      getStateWiseCoverageList: 'admin/stateWiseCoverage/list',
      updateCoverageStatus: 'admin/stateWiseCoverage/update-status',
      getCoerageDetails:
        'admin/stateWiseCoverage/GetStateWiseCoveragesById/{StateWiseCoverageId}',
      deleteStateWiseCoverageById: 'admin/stateWiseCoverage/delete-coverage',
      getValidationRanges: 'admin/stateWiseCoverage/validation-ranges',
      getCoverageCategories: 'admin/stateWiseCoverage/get-coverage-categories',
      getIsStateMandatoryCoverageWise:
        'admin/stateWiseCoverage/get-state-mandatory',
    },
    termsAndConditionsMaster: {
      getTermsAndConditions: 'admin/termsAndConditions/GetTermsAndConditions',
      addUpdateTermsAndConditions:
        'admin/termsAndConditions/AddUpdateTermsAndConditions',
    },
    carMakeMaster: {
      getCarMakeMasterList: 'admin/carMake/car-make-list',
      getCarMakeDetailsById: 'admin/carMake/car-make-details/{CarMakeId}',
      carMakeDelete: 'admin/carMake/car-make-delete/{CarMakeId}',
      importFile: 'admin/carMake/ImportFile',
      saveCarMake: 'admin/carMake/save-car-make',
      downloadSampleFile: 'admin/carMake/downloadSampleFile',
      exportCarMakeMasterData: 'admin/carMake/ExportCarMakeTypes',
      syncFromVehicleApi: 'admin/carMake/sync-from-vehicle-api',
    },
    bodilyInjury: {
      getBodilyInjuryList: 'admin/BodilyInjuries/List',
      addUpdateBodilyInjury: 'admin/BodilyInjuries/AddUpdate',
      deleteBodilyInjury: 'admin/BodilyInjuries/Delete',
    },
    propertyDamage: {
      getPropertyDamageList: 'admin/PropertyDamage/List',
      addUpdatePropertyDamage: 'admin/PropertyDamage/AddUpdate',
      deletePropertyDamage: 'admin/PropertyDamage/Delete',
    },
    uninsuredUnderinsuredMotorist: {
      getUninsuredUnderinsuredMotoristList:
        'admin/UninsuredUnderinsuredMotorist/List',
      addUpdateUninsuredUnderinsuredMotorist:
        'admin/UninsuredUnderinsuredMotorist/AddUpdate',
      deleteUninsuredUnderinsuredMotorist:
        'admin/UninsuredUnderinsuredMotorist/Delete',
    },
    medicalPayments: {
      getMedicalPaymentsList: 'admin/MedicalPayments/List',
      addUpdateMedicalPayments: 'admin/MedicalPayments/AddUpdate',
      deleteMedicalPayments: 'admin/MedicalPayments/Delete',
    },
    collisionDeductible: {
      getCollisionDeductibleList: 'admin/collisionDeductible/list',
      getCollisionDeductibleById: 'admin/collisionDeductible/GetById',
      addUpdateCollisionDeductible: 'admin/collisionDeductible/AddUpdate',
      deleteCollisionDeductible: 'admin/collisionDeductible/Delete',
    },
    towingRoadsideAssistance: {
      getTowingRoadsideAssistanceList: 'admin/towingRoadsideAssistance/list',
      getTowingRoadsideAssistanceById: 'admin/towingRoadsideAssistance/GetById',
      addUpdateTowingRoadsideAssistance:
        'admin/towingRoadsideAssistance/AddUpdate',
      deleteTowingRoadsideAssistance: 'admin/towingRoadsideAssistance/Delete',
    },
    customerRegistration: {
      savePrimaryInsured: 'customer-registration/primary-insured/save',
      saveLicensedDrivers: 'customer-registration/licensed-drivers/save',
      removeLicensedDrivers: 'customer-registration/licensed-drivers/delete',
      getLicensedDriverDetailMasterData:
        'customer-registration/licensed-drivers/master-data',
      getAddressData: 'admin/AddressMaster/list/{zipCode}',
      getPrimaryInsuredMasterData:
        'customer-registration/primary-insured/master-data',
      getLicensedDriverDetails:
        'customer-registration/licensed-drivers/licensed-driver-details?leadId={Id}',
      saveVehicles: 'customer-registration/vehicles/save',
      deleteVehicles: 'customer-registration/vehicles/delete',
      saveContactPreference: 'customer-registration/contact-prefrence/save',
      getVehicleMasterData: 'customer-registration/vehicles/master-data',
      saveDrivingRecords: 'customer-registration/driving-records/save',
      getDrivingRecordDetails:
        'customer-registration/driving-records/GetDrivingRecords/{leadId}/{driverId}',
      deleteAccident:
        'customer-registration/driving-records/delete-accident/{drivingAccidentId}',
      deleteTrafficTicket:
        'customer-registration/driving-records/delete-traffic-ticket/{ticketId}',
      deleteMovingViolation:
        'customer-registration/driving-records/delete-moving-violation/{violationDriverId}',
      getVehicleMakeList: 'admin/AddressMaster/make-list/{year}',
      getVehicleModelList: 'admin/AddressMaster/model-list/{year}/{make}',
      getVehicleSubModelList:
        'admin/AddressMaster/submodel-list/{year}/{make}/{model}',
      getVehicleTypeList:
        'admin/AddressMaster/vehicleType-list/{year}/{make}/{model}/{submodel}',
      getVehicleDisplayNameList:
        'admin/AddressMaster/vehicleDisplayName-list/{year}/{make}/{model}/{submodel}',
      getLicensedDriverByLeadId:
        'customer-registration/driving-records/GetDrivers?leadId={leadId}',
      getPrimaryInsuredByUserId:
        'customer-registration/primary-insured/get-by-userid',
      getPrimaryInsuredbyLeadId:
        'customer-registration/primary-insured/get-by-leadid/{LeadId}',
      getVehicleDetailById: 'customer-registration/vehicles/get-by-id/{leadId}',
      getCustomerContactPreference:
        'customer-registration/contact-prefrence/get-contact-prefrenceById/{LeadId}',
      getVehicleForBankByLeadId:
        'customer-registration/bankOrLienHolder/GetVehicleDetails/{LeadId}',
      saveBankOrLienHolder: 'customer-registration/bankOrLienHolder/save',
      saveInsurer: 'customer-registration/insurer/save',
      getInsurerDetailById: 'customer-registration/insurer/get-by-id/{leadId}',
      getInsurerMasterData: 'customer-registration/insurer/master-data',
      getCoverageMasterData:
        'customer-registration/coverage-limits/master-data',
      addUpdateCoverageLimits: 'customer-registration/coverage-limits/save',
      GetCoverageLimitsById:
        'customer-registration/coverage-limits/get-by-id/{leadId}',
      getCoverageLimitsFormsDetails:
        'customer-registration/coverage-limits/get-froms-details',
      getUploadDocumentsMasterData:
        'customer-registration/upload-documents/master-data',
      saveUploadDocuments: 'customer-registration/upload-documents/save',
      getCustomerUploadedDocuments:
        'customer-registration/upload-documents/getCustomerDocById/{leadId}',
      removeCustomerDocument: 'customer-registration/upload-documents/delete',
      saveLeadStatus: 'customer-registration/upload-documents/modify',
      getContactPreferenceViewHistory:
        'customer-registration/contact-prefrence/view-history?leadId={Id}',
      getTransformedDrivingRecords:
        'customer-registration/driving-records/get-transformed-driving-records/{leadId}/{driverId}',
      downloadFile: 'customer-registration/upload-documents/download',
      getCustomerCoverageLimitsFormsDetails:
        'customer-registration/coverage-limits/get-coverage-froms-details',
      getCustomerCoverageLimitsStateWise:
        'customer-registration/coverage-limits/coverage-limits-state-wise',
      getAdminCustomerList: 'customer-registration/primary-insured/GetAdminCustomerList',
      modifyCustomerStatus: 'customer-registration/primary-insured/modify-customer-status',
      getMovingViolation: 'customer-registration/driving-records/GetMovingViolation/{leadId}/{driverId}',
      getLienholderDetails: 'customer-registration/driving-records/GetLienHolderList'
    },
    DropDownList: {
      DropDown: 'admin/DropDown/List',
      EnumLicenseStatusDropDown: 'admin/DropDown/get-enum-license-status-list',
      EnumGenderList: 'admin/DropDown/get-enum-gender',
      SweetSpotHistoryDate:
        'admin/DropDown/get-sweet-spot-history-date/{SweetSpotId}',
      EnumApplicabilityList: 'admin/DropDown/get-enum-applicability-list',
    },
    signUp: {
      userSignUp: 'common/signUp/save-user-details',
      verifyOtp: 'common/signUp/verify-otp',
      addSignUpQuestion: 'common/signUp/add-SignUp-Question',
      resendOTP: 'common/signUp/resend-OTP/{Email}',
      getOTPDataByEmail: 'common/signUp/GetOTPDataByEmail',
      getHearedAboutUs: 'common/signUp/getlist-heared-AboutUs',
      getCustomerIncompleteInfo: 'common/signUp/get-customer-incomplete-info',
    },
    VehicleType: {
      SaveVehicleType: 'admin/vehicle-type/save',
      GetVehicleType: 'admin/vehicle-type/list',
      DeleteVehicleType: 'admin/vehicle-type/delete/{VehiclTypeId}',
    },
    FirmRegistration: {
      GetStateCountyCity: 'firmRegistration/GetStateCountyCity',
      GetUploadedDocuments:
        'firmRegistration/get-firm-uploaded-documents/{FirmId}',
      GetLicenseTypeForFirm: 'firmRegistration/get-firm-license-type/{FirmId}',
      DeleteFirmUploadedDocuments:
        'firmRegistration/delete-firm-uploaded-document',
      UpdateBannerAndLogo: 'firmRegistration/upload-firm-banner-logo',
      UploadFirmLicenseDocuments:
        'firmRegistration/upload-firm-license-documents',
      UploadFirmDocuments: 'firmRegistration/firm-upload-documents',
      GetZipCodes: 'firmRegistration/zipcode-list',
      SaveFirm: 'firmRegistration/save',
      SaveFirmAgents: 'firmRegistration/SaveFirmAgents',
      RegisterFirm: 'firmRegistration/register-firm',
      GetAdminFirmList: 'firmRegistration/GetAdminFirmList',
      GetFirmById: 'firmRegistration/get-firm-details-by-id',
      CheckApproval: 'firmRegistration/check-approval',
      GetFirmReferenceId: 'firmRegistration/get-firm-reference-id',
      GetFirmDashboardData: 'firmRegistration/get-firm-dashboard-data',
      ResendAgentSignupEmail: 'firmRegistration/resend-email-agent-signup',
      FirmLicenseDocumentApprove: 'firmRegistration/license-approval',
      ActivateFirmLicenseDocument: 'firmRegistration/license-document-active',
      AllowAddCustomer: 'firmRegistration/allow-add-customer',
      NoPaymentRequired: 'firmRegistration/no-payment-required',
      updateFirmAllowAddCustomer: 'firmRegistration/firm-allow-add-customer',
      ApproveRejectFirm: 'firmRegistration/approve-reject-firm',
    },
    reportManagement: {
      getCustomerReportList: 'admin/ReportManagement/GetCustomerReportList',
      getFirmReportList: 'admin/ReportManagement/GetFirmReportList',
      getAgentReportList: 'admin/ReportManagement/GetAgentReportList',
      exportCustomerReportList: 'admin/ReportManagement/ExportCustomerReportList',
      exportReportList: 'admin/ReportManagement/ExportReportList',
    },
    Agent: {
      AddUpdateAgent: 'agent/AddUpdateAgent',
      GetAgentById: 'agent/GetAgentById',
      GetAgentProfile: 'agent/GetAgentProfile',
      addCustomerProfile: 'agent/AddCustomerProfile',
      GetAgentList: 'agent/list',
      sendSignupLink: 'agent/SendSignupLink',
      changeStatus: 'agent/ToggleLicense',
      DeleteAgent: 'agent/DeleteAgent',
      GetAgentDashboardData: 'agent/get-agent-dashboard-data',
      ChangeAgentStatus: 'agent/change-status',
      agentLicenseDocumentApprove: 'agent/license-document-approve',
      updateAgentAllowAddCustomer: 'agent/agent-allow-add-customer',
      addCustomerReferral: 'agent/add-customer-referral',
      sendReferral: 'agent/send-referral',
      updateReferralStatus: 'agent/update-referral-status',
    },
    productAvailabilityMaster: {
      getProductAvailabilityList: 'admin/product-availability/list',
      saveProductAvailability:
        'admin/product-availability/save-product-availability',
      deleteProductAvailability: 'admin/product-availability/delete',
      exportProductAvailability:
        'admin/product-availability/ExportProductAvailibility',
      importProductAvailability: 'admin/product-availability/upload',
    },
    DemoAppointment: {
      GetdemoAppointment: 'admin/DemoAppointmentMaster/list',
      DeleteDemoAppointment:
        'admin/DemoAppointmentMaster/delete/{DemoAppointmentId}',
      AddUpdateDemoAppointment: 'admin/DemoAppointmentMaster/DemoAppointment',
      getDemoAppointmentById: 'admin/DemoAppointmentMaster/GetById',
    },

    BookAppointment: {
      getDemoAppointmentById: 'common/BookAppointment/GetFirmDetails',
      AddBookAppointment: 'common/BookAppointment/BookAppointment',
      GetBookAppointmentDesiredSlot: 'common/BookAppointment/GetDesiredSlot',
      GetBookAppointmentDesiredSlotNew: 'common/BookAppointment/GetDesiredSlotNew',
      GetBookedAvailableDate: 'common/BookAppointment/GetBookedAvailableDate',
      GetfirmDemoBookAppointmentList:
        'common/BookAppointment/GetFirmDemoAppointmentList',
      GetfirmDemoBookAppointmentListById:
        'common/BookAppointment/GetFirmDemoAppointmentListById',
      DeleteFirmDemoAppointment: 'common/BookAppointment/delete/{FirmDemoId}',
    },
    User: {
      login: 'common/user/login',
      getUserDetails: 'common/user/get-userDetails',
    },
    forgetPassword: {
      getSignUpQuestion: 'common/user/signUp-question',
      validateQuestionAnswers: 'common/user/signup-question-answers',
      getUserType: 'common/user/get-usertype',
      // updateUserPassword: 'common/user/update-password', // checkign
      forgetPassword: 'common/user/forgot-password',
      resetPassword: 'common/user/reset-password',
      verifyOTP: 'common/user/verify-otp',
      forgotPasswordByEmail: 'common/user/forgot-password',
    },
    myRequest: {
      getLeadNumberDDLList: 'customer/my-request/lead-list/{customerId}',
      getLeadRequestList:
        'customer/my-request/lead-request-list/{leadId}/{customerId}',
      getLeadData: 'customer/my-request/get-lead-data?leadId={leadId}',
      getRequestDetailData: 'customer/my-request/get-request-detail/{leadId}',
      getexclusivedetails: 'customer/my-request/exclusive-popup/{customerId}',
      notifyAgent: 'customer/my-request/notify-agent/{customerId}'
    },
    HouseHoldStatus: {
      getHouseResidentTypeList:
        'sweet-spot/HouseHoldStatus/GetHouseResidentTypeDetailsList',
      SaveUpdateHouseholdHouseType:
        'sweet-spot/HouseHoldStatus/SaveUpdateHouseholdHouseType',
      SaveUpdateHouseholdResidentType:
        'sweet-spot/HouseHoldStatus/SaveUpdateHouseholdResidentType',
      SaveUpdatenumberofLicensedHouseholdMember:
        'sweet-spot/HouseHoldStatus/SaveUpdateHouseholdLicenceHouseHoldMember',
      GetSweetSpotHouseholdStatusListById:
        'sweet-spot/HouseHoldStatus/GetSweetSpotHouseholdStatusListById',
      GetSweetSpotHouseHoldHouseTypeHistoryById:
        'sweet-spot/HouseHoldStatus/GetSweetSpotHouseHoldHouseTypeHistoryById',
      GetSweetSpotHouseHoldResidentTypeHistoryById:
        'sweet-spot/HouseHoldStatus/GetSweetSpotHouseHoldResidentTypeHistoryById',
      GetSweetSpotHouseHoldMemberHistoryById:
        'sweet-spot/HouseHoldStatus/GetSweetSpotHouseHoldMemberHistoryById',
      GetSweetSpotHouseHoldStatusHistory:
        'sweet-spot/HouseHoldStatus/get-sweet-spot-House-hold-status-history',
    },
    SweetSpotDrivingRecord: {
      GetSweetSpotDrivingRecordList:
        'sweet-spot/driving-record/get-sweet-spot-driving-record/{SweetSpotId}',
      GetSweetSpotDrivingRecordHistory:
        'sweet-spot/driving-record/get-sweet-spot-driving-record-history',
      SaveSweetSpotDefenciveDriving:
        'sweet-spot/driving-record/save-sweet-spot-defencive-driving',
      SaveSweetSpotDrivingAccidentAtFaultRange:
        'sweet-spot/driving-record/save-sweet-spot-driving-accident-at-fault',
      SaveSweetSpotDrivingAccidentNonFaultRange:
        'sweet-spot/driving-record/save-sweet-spot-driving-accident-non-fault',
      SaveSweetSpotDrivingLicenseStatus:
        'sweet-spot/driving-record/save-sweet-spot-driving-license-status',
      SaveSweetSpotDrivingLicenseType:
        'sweet-spot/driving-record/save-sweet-spot-driving-license-type',
      SaveSweetSpotDrivingLicenseYearRange:
        'sweet-spot/driving-record/save-sweet-spot-driving-license-year',
      SaveSweetSpotMajorTrafficViolation:
        'sweet-spot/driving-record/save-sweet-spot-major-traffic-violation',
      SaveSweetSpotTotalDrivingIncident:
        'sweet-spot/driving-record/save-sweet-spot-total-driving-incident',
      SaveSweetSpotTrafficViolationRange:
        'sweet-spot/driving-record/save-sweet-spot-traffic-violation',
    },
    SweetSpotpipeline: {
      GetSweetSpotPipelineList: 'sweet-spot/get-sweet-spot-pipeline-list',
      SaveSweetSpotPipeline: 'sweet-spot/save-sweet-spot-pipeline',
      UpdateSweetSpotStatus: 'sweet-spot/save-sweet-spot-status',
      GetSweetSpotById: 'sweet-spot/get-sweetspot-by-id/{SweetSpotId}',
    },
    SweetSpotDemographics: {
      getSweetSpotDemographics:
        'sweet-spot/demographic/get-sweet-spot-demographics',
      getSweetSpotDemographicsHistory:
        'sweet-spot/demographic/get-sweet-spot-demographics-history',
      getSweetSpotDemographicsAgeHistory:
        'sweet-spot/demographic/get-sweet-spot-demographics-age-history',
      saveDemographics: 'sweet-spot/demographic/save-demographics',
      saveDemographicAgeRange:
        'sweet-spot/demographic/save-demographics-age-range',
      getDemographicAgeRange: 'sweet-spot/demographic/get-age-range',
      getsweetspotsubheader: 'sweet-spot/demographic/get-sweet-spot-subheader/{tabname}'
    },
    leadGenerationSource: {
      GetLeadGenerationSourceList:
        'SweetSpot/LeadGenerationSource/GetLeadGenerationSourceList',
      AddUpdateLeadGenerationSource:
        'SweetSpot/LeadGenerationSource/AddUpdateLeadGenerationSource',
      GetLeadGenerationSourceById:
        'SweetSpot/LeadGenerationSource/GetLeadGenerationSourceById',
      GetLeadGenerationSourceHistoryById:
        'SweetSpot/LeadGenerationSource/GetLeadGenerationSourceHistoryById',
      ManageSweetSpotActivity:
        'SweetSpot/LeadGenerationSource/manage-sweet-spot-activity',
    },
    sweetSpotCustomerContactPrefrence: {
      getSweetSpotCustomerContactPrefrenceList:
        'sweet-spot/customer-contact-prefrence/GetList',
      addUpdateSweetSpotCustomerContactPrefrence:
        'sweet-spot/customer-contact-prefrence/AddUpdate',
      getSweetSpotCustomerContactPrefrenceById:
        'sweet-spot/customer-contact-prefrence/Sweet-Spot-Id',
      getSweetSpotCustomerContactPrefrenceHistoryList:
        'sweet-spot/customer-contact-prefrence/GetHistoryList',
    },
    sweetSpotVehicleInformation: {
      getCarMakeYearList: 'sweet-spot/vehicle-information/GetCarMakeYearList',
      saveVehicleInformationCarAndYear: 'sweet-spot/vehicle-information/SaveVehicleInformationCarAndYear',
      getCarMakeMasterMakeList: 'sweet-spot/vehicle-information/GetCarMakeMasterMakeList',
      getCarMakeMasterDisplayNameList: 'sweet-spot/vehicle-information/GetCarMakeMasterDisplayNameList',
      getCarMakeMasterModelList: 'sweet-spot/vehicle-information/GetCarMakeMasterModelList',
      getCarMakeMasterSubModelList: 'sweet-spot/vehicle-information/GetCarMakeMasterSubModelList',
      saveVehicleInformation: 'sweet-spot/vehicle-information/SaveVehicleInformation',
      getVehicleInformationCarAndYearById: 'sweet-spot/vehicle-information/GetVehicleInformationCarAndYearById',
      GetVehicleInformationOwnershipTypeById: 'sweet-spot/vehicle-information/GetVehicleInformationOwnershipTypeById',
      saveVehicleInformationOwnershipType: 'sweet-spot/vehicle-information/SaveVehicleInformationOwnershipType',
      getHistoryList: 'sweet-spot/vehicle-information/GetHistoryList'
    },
    CoverageValueRangeMaster: {
      getCoverageValueRange: 'admin/coverage-value-range/list',
      saveCoverageValueRange: 'admin/coverage-value-range/save',
      deleteCoverageValueRange:
        'admin/coverage-value-range/delete/{coverageValueRangeId}',
      getListCountOfDoubleDropdown:
        'admin/coverage-value-range/GetCoverageValueRangeListCount',
    },
    ConfigMaster: {
      getList: 'admin/config/list',
      save: 'admin/config/save',
      delete: 'admin/config/delete/{configId}',
      getNumericCount: 'admin/config/numeric-count',
    },
    IsScore: {
      save: 'is-score/save',
      getByLead: 'is-score/{leadId}',
    },
    CurrentCarrierHistory: {
      GetCurrentCarrierHistoryList:
        'sweet-spot/current-carrier-history/GetCurrentCarrierHistoryList',
      AddUpdateCurrentCarrierHistory:
        'sweet-spot/current-carrier-history/AddUpdateInsuranceCarrier',
      GetInsuranceCarrierById:
        'sweet-spot/current-carrier-history/GetInsuranceCarrierById',
      AddUpdateCurrentCarrierHistoryCurrentInsurance:
        'sweet-spot/current-carrier-history/AddUpdateCurrentCarrier',
      GetCurrentCarrierById:
        'sweet-spot/current-carrier-history/GetCurrentCarrierById',
      AddUpdateAllCarrierHistoryCurrentInsurance:
        'sweet-spot/current-carrier-history/AddUpdateAllCarrier',
      GetAllCarrierById: 'sweet-spot/current-carrier-history/GetAllCarrierById',
      GetInsuranceCarrierHistory:
        'sweet-spot/current-carrier-history/GetInsuranceCarrierHistoryHistoryById',
      GetCurrentCarrierHistory:
        'sweet-spot/current-carrier-history/GetCurrentCarrierHistoryHistoryById',
      GetAllCarrierHistory:
        'sweet-spot/current-carrier-history/GetAllCarrierHistoryHistoryById',
    },
    sweetSpotGeographic: {
      addUpdateSweetSpotGeographic:
        'sweetSpot/geographic/AddUpdateSweetSpotGeographic',
      getSweetSpotGeographic: 'sweetSpot/geographic/GetSweetSpotGeographic',
      getSweetSpotGeographicState:
        'sweetSpot/geographic/GetSweetSpotGeographicState',
      getSweetSpotGeographicList:
        'sweetSpot/geographic/GetSweetSpotGeographicList',
      GetSweetSpotGeographicHistory:
        'sweetSpot/geographic/GetSweetSpotGeographicHistory',
    },
    sweetSpotApplicability: {
      getSweetSpotApplicabilityList:
        'sweet-spot/applicability/get-sweet-spot-applicability/{SweetSpotId}',
      saveSweetSpotApplicability:
        'sweet-spot/applicability/save-sweet-spot-applicability',
      getSweetSpotApplicabilityHistory:
        'sweet-spot/applicability/get-sweet-spot-applicability-history',
    },
    sweetSpotCoverageLimit: {
      getStateWiseCoverageList:
        'sweet-spot/coverage-limit/Get-StateWise-Coverages',
      getUserCoverageByStateId:
        'sweet-spot/coverage-limit/Get-User-SweetSpotCoverageLimit-By-StateId',
      addUpdateStateWiseCoverage:
        'sweet-spot/coverage-limit/Save-Sweetspot-Coverage-limit',
      getStateWiseCoverageStateist:
        'sweet-spot/coverage-limit/Get-StatewiseCoverage-StateList',
      getCoverageStateListBySweetSpotId:
        'sweet-spot/coverage-limit/Get-Coverage-StateList-By-SweetSpotId',
      getSelectedSweetSpotCoverage:
        'sweet-spot/coverage-limit/Get-SelectedSweetSpotCoverageLimit-By-StateId',
      getSweetSpotCoverageLimitHistory:
        'sweet-spot/coverage-limit/get-sweet-spot-coveragelimit-history',
    },
    leadMaster: {
      getLeadMasterList: 'admin/LeadMaster/list',
      addNumberOfAgentToReceivelead: 'admin/LeadMaster/save',
      getNumberOfAgentToReceivelead:
        'admin/LeadMaster/get-number-of-receiveLead',
      addReferralAmountMaster: 'admin/LeadMaster/save-referral-amount',
      getReferralAmountData: 'admin/LeadMaster/get-referral-amount',
      saveNumberOfAgentToPurchaseLead: 'admin/LeadMaster/save-purchase-lead',
      getNumberOfAgentToPurchaseLead: 'admin/LeadMaster/get-number-of-purchase-lead',
      UpdateFirmIdInUser: 'admin/LeadMaster/UpdateFirmIdInUser'
    },
    leadPurchaseMaster: {
      getLeadPurchaseList: 'admin/lead-purchase-master/list',
      saveLeadPurchase: 'admin/lead-purchase-master/save',
      deleteLeadPurchase:
        'admin/lead-purchase-master/delete/{LeadPurchaseMasterId}',
      getLeadPurchaseHistoryList:
        'admin/lead-purchase-master/view-history?leadPurchaseId={Id}',
    },
    common: {
      getColumnPreferences: 'common/get-column-preferences-by-listname',
      saveColumnPreferences: 'common/save-column-preferences',
      getColumnData: 'common/get-column-data',
      SuscribeStayConnect: 'common/Suscribe',
      getComingSoonList: 'common/list',
      getClientLocation: 'common/get-client-location',
      getStateConfigrationList: 'common/StateConfigration/list',
      checkStateConfiguration: 'common/StateConfigration/CheckStateConfiguration',
    },
    mymacthes: {
      GetMyMatchesList: 'MyMatches/MyMatchesList',
      GetMyMatchesByLeadId: 'MyMatches/GetMyMatchesByLeadId',
      PurchaseLead: 'MyMatches/AddPurchaseLead',
      setLikeStatus: 'MyMatches/SetLikeStatus',
      exportMyMatches: 'MyMatches/export-MyMatches',
      getColumnData: 'MyMatches/get-column-data',
      getMyMatchesViewHistory: 'MyMatches/get-view-history'
    },
    myLeads: {
      getMyLeadsList: 'my-leads/list',
      getMyLeadsListById: 'my-leads/get-by-id',
      getColumnData: 'my-leads/get-column-data',
      exportMyLeads: 'my-leads/export-leads',
    },
    soldLeads: {
      getSoldLeadsList: 'sold-leads/list',
      getSoldLeadsListById: 'sold-leads/get-by-id',
      getColumnData: 'sold-leads/get-column-<data',
      exportSoldLeads: 'sold-leads/export-sold-leads',
    },
    privacyPolicyMaster: {
      getprivacyPolicy: 'admin/privacy-policy/get',
      savePrivacyPolicy: 'admin/privacy-policy/save',
    },
    myQuotes: {
      GetMyQuotesList: 'MyQuotes/MyQuotesList',
      GetQuoteByLeadId: 'MyQuotes/GetQuoteByLeadId',
      getColumnData: 'MyQuotes/get-column-data',
      getCustomerInformation: 'firmRegistration/get-customer-info/{LeadId}',
      saveQuoteDetails: 'firm/submit-quote',
      getQuoteDetails: 'firm/get-quote-details/{leadId}',
      exportMyQuotes: 'MyQuotes/export-quotes',
    },
    firmRatingMaster: {
      saveFirmRating: 'common/firm-rating/save',
      getFirmRatingListByFirmId: 'common/firm-rating/GetFirmRatingListByFirmId',
      getFirmRatingByFirmRatingId: 'common/firm-rating/GetFirmRatingById',
      DeleteFirmRatingById: 'common/firm-rating/delete',
    },
    firmRatingReportMaster: {
      saveFirmRatingReport: 'common/firmRatingReport/save',
      saveFirmRatingCommentReport: 'common/firmRatingReport/comment-report'
    },
    firmRatingLikeMaster: {
      saveFirmRatingLike: 'common/firm-rating/like',
    },
    firmRatingCommentMaster: {
      saveFirmRatingComment: 'common/firm-rating/comment',
      getFirmRatingCommentList: 'common/firm-rating/GetFirmRatingCommentList/{FirmId}/{FirmRatingId}',
      downloadAttachment: 'common/firm-rating/download/{FileName}',
      updateFirmRatingComment: 'common/firm-rating/UpdateComment',
      deleteFirmRatingComment: 'common/firm-rating/delete/{firmRatingCommentId}',
      deleteFirmRatingAttachment: 'common/firm-rating/delete-attachment/{firmRatingCommentId}/{attachmentId}',
    },
    approval: {
      getApprovalList: 'approval/approval-list',
      approvePendingLead: 'approval/approve-lead',
      getApprovalById:
        'approval/get-by-id/{LicensedDriverDetailHistoryId}/{leadId}',
      getMyMatchesListByCustomer: 'approval/MyMatchesListByCustomer',
      AddMyMatchesLikedDisliked: 'MyMatches/SetLikeStatus',
      GetCustomerColumnData: 'approval/get-customer-column-data',
      saveQuoteCustomerInterest: 'approval/save-customer-interest',
      GetCustomerMatchesByLeadId: 'approval/get-customer-matches-by-id',
      GetCustomerMatchesNotesById: 'approval/get-matches-notes-by-id',
      GetApprovalDemographicViewById: 'approval/view-primary-insured/{leadId}',
      GetApprovalLicensedDriverViewById:
        'approval/view-licensed-driver-detail/{leadId}',
      GetApprovalDrivingRecordViewById:
        'approval/view-driving-record-detail/{leadId}',
      GetApprovalHouseHoldVehicleViewById:
        'approval/view-household-vehicle-detail/{leadId}',
      GetApprovalLienViewById: 'approval/view-lien-detail/{leadId}',
      GetApprovalCoverageLimitViewById:
        'approval/view-coverage-limit-detail/{leadId}',
      GetApprovalInsuranceViewById: 'approval/view-insurance-detail/{leadId}',
      GetApprovalDocumentViewById: 'approval/view-document-detail/{leadId}',
      getCustomerApprovalCoverageLimitsViewDetails:
        'approval/view-coverage-limit-detail/{leadId}',
      GetDrivingRecordViewForApproval:
        'approval/get-transformed-driving-records-approval/{leadId}',
      UpdateProfileStatus: 'approval/approve-reject-request',
    },
    quotes: {
      submitquote: 'firm/submit-quote',
    },
    disputeMaster: {
      saveCustomerDisputeMaster: 'common/dispute-master/save-customer-dispute',
      getFirmAgentListByLeadId:
        'common/dispute-master/GetFirmAgentListByLeadId',
      getCustomerDisputeMasterList:
        'common/dispute-master/GetCustomerDisputeMasterList',
      getCustomerDisputeMasterById:
        'common/dispute-master/GetCustomerDisputeMasterById',
      getCustomerDisputeMasterAdminList:
        'common/dispute-master/GetCustomerDisputeMasterAdminList',
      deleteCustomerDisputeMaster: 'common/dispute-master/Delete',
      getListByFirmAgentId: 'common/dispute-master/GetListByFirmAgentId',
      numberOfCustomerDisputeForAdmin:
        'common/dispute-master/NumberOfCustomerDisputeForAdmin',
      numberOfCustomerDisputeForFirmAgent: 'common/dispute-master/number-of-disputes-firm-agent',
      saveLog: 'common/dispute-master/save-log',
      getLogs: 'common/dispute-master/get-logs',
      getallstatus: 'common/dispute-master/get-status'
    },
    contactUs: {
      getContactUsList: 'admin/contactUs/list',
      saveContactUs: 'admin/contactUs/save',
      saveLog: 'admin/contactUs/save-log',
      getLogs: 'admin/contactUs/get-logs',
      getallstatus:'admin/contactUs/get-status'
    },
    howItWorks: {
      getHowItWorksList: 'admin/howItWorks/list',
      saveHowItWorks: 'admin/howItWorks/save',
      getHowItWorksDetails: 'admin/howItWorks/details/{Id}',
      saveHowItWorksLogs: 'admin/howItWorks/SaveHowItWorksLogs',
      getHowItWorksLogs: 'admin/howItWorks/GetHowItWorksLogList/{HowItWorksId}',
    },
    walletCredentialConfig: {
      saveWalletCreditConfiguration: 'admin/wallet-credit-configuration/save',
      getWalletCreditConfiguration: 'admin/wallet-credit-configuration/get',
    },
    withdrawalDateConfig: {
      getWithdrawalConfig: 'admin/payout/withdrawal-config',
      saveWithdrawalConfig: 'admin/payout/withdrawal-config',
    },
    stripePayment: {
      CreatePaymentIntent: 'stripe/create-payment-intent',
      CancelPaymentIntent: 'stripe/cancel-payment-intent',
    },
    stripeSubscription: {
      CreateCheckoutSession: 'stripe/create-checkout-session',
      GetSubscriptionPlans: 'stripe/subscription-plans/{CountryName}',
      SessionStatus: 'stripe/session-status/{SessionId}',
      CancelSubscription: 'stripe/cancel-subscription',
      ResumeSubscription: 'stripe/resume-subscription',
    },
    transaction: {
      GetCreditTransactionList: 'transaction/get-credit-list',
      GetPaymentTransactionList: 'transaction/get-payment-list',
      getColumnData: 'transaction/get-column-data',
      exportFirmBalance: 'transaction/export-FirmBalance',
      getMySubscriptionlist: 'stripe/firm-subscription-plans',
      getLVFirmSubscriptionslist: 'stripe/firm-lv-subscriptions',
      getAutoPayList: 'stripe/firm-auto-pay'
    },
    Analytics: {
      getFirmWithExpiredLicenses: 'Analytics/firm-license-expired',
      getLeadNotMatchedList: 'Analytics/lead-not-matched-list',
      getFirmWithIncompleteInformation: 'Analytics/firm-incompleteprofile-list',
      getGrossPointRevenueFromLead: 'Analytics/grossPoints-revenue-from-lead-list',
      getMatchedFirmScoreCardOrder: 'Analytics/matched-firm-scorecard-order',
      getFirmPriorityScoreReport: 'Analytics/firm-priority-score-report',
      getFirmEarnedCreditPointReport: 'Analytics/firm-earned-credit-point',
      getFirmWithDepletedWallets: 'Analytics/firm-with-depleted-wallets',
      getFirmAgentReferralReport: 'Analytics/firm-agent-referral',
      getAgentWithExpiredLicenses: 'Analytics/agent-with-expired-licenses',
      getFirmAgentReferralNotApprovedReport: 'Analytics/firm-agent-referral-not-approved',
      getFirmAgentEarnedCreditReport: 'Analytics/firm-agent-earned-credit',
      getCustomerWithIncompleteInfor: 'Analytics/customer-incompleteprofile-list',
      getAgentWithIncompleteInformation: 'Analytics/agent-with-incomplete-information',
      getAnalyticsNewAgents: 'Analytics/new-agents'
    },
    licenseTypeMaster: {
      getLicenseTypeMasterList: 'admin/license-type/list',
      getLicenseTypeMasterById:
        'admin/license-type/GetById?licenseTypeId={licenseTypeId}',
      addUpdateLicenseTypeMaster: 'admin/license-type/save',
      deleteLicenseType: 'admin/license-type/delete/{licenseTypeId}',
    },
    CustomerReferrals: {
      getCustomerReferralsList: 'firmRegistration/customer-referrals-list',
      getCustomerReferralColumnData:
        'firmRegistration/get-customer-referrals-columns',
      exportCustomerReferrals: 'firmRegistration/export-customer-referrals',
    },
    FirmReferrals: {
      getFirmReferralsList: 'firmRegistration/firm-referrals-list',
      getFirmReferralColumnData: 'firmRegistration/get-firm-referrals-columns',
      exportFirmReferrals: 'firmRegistration/export-firm-referrals',
    },
    // FirmRef feature - firm's own referrals (the "Firm Referrals" tab)
    MyFirmReferrals: {
      getList: 'firmReferral/my-firm-referrals-list',
      getColumnData: 'firmReferral/get-my-firm-referrals-columns',
      export: 'firmReferral/export-my-firm-referrals',
      referralLink: 'firmReferral/referral-link',
      validateReferralCode: 'firmReferral/validate-referral-code/',
    },
    susbcriptionPlanMaster: {
      saveSubscriptionPlanMaster: 'stripe/save-subscription-plan',
      setSubscriptionPlanMasterStatus: 'stripe/set-subscription-plan-status',
      deleteSubscriptionPlanMaster: 'stripe/delete-subscription-plan',
      getSubscriptionPlanList: 'stripe/subscription-list',
    },
    addOnProductMaster: {
      getList: 'admin/addon-product/list',
      save: 'admin/addon-product/save',
      delete: 'admin/addon-product/delete',
      activeInactive: 'admin/addon-product/active-inactive',
    },
    AdminProfile: {
      saveAdminProfileImage: 'admin/AdminProfile/SaveAdminProfile',
      getAdminProfileData: 'admin/AdminProfile/details/{userId}',
      SaveAdminProfileData: 'admin/AdminProfile/SaveData',
    },
    aboutUs: {
      getAboutUs: 'admin/privacy-policy/get-about-us',
      saveAboutUs: 'admin/privacy-policy/save-about-us',
    },
    reportedReviewmaster: {
      getReportedReviewList: 'admin/ReportReviewMaster/list',
      getReportReviewDetailsById: 'admin/ReportReviewMaster/GetById/{FirmRatingId}',
      deleteReportedReview: 'admin/ReportReviewMaster/delete/{FirmRatingId}',
      deleteReportedComment: 'admin/ReportReviewMaster/delete-comment-report/{FirmRatingCommentReportId}/{FirmRatingCommentId}'
    },
    notification: {
      getNotificationList: 'notifications/list',
      getNotificationById: 'notifications/get-by-id/{NotificationId}',
      updateViewStatus: 'notifications/update-viewed-notification',
      updateNotificationReadAll: 'notifications/update-notification-read-all',
      saveNotification: 'notifications/save',
      deleteNotification: 'notifications/delete'
    },
    userManagement: {
      getuserManagementList: 'admin-user/list',
      getRoleDropdownData: 'admin-user/role-master-data',
      saveAdminUserdetails: 'admin-user/save',
      assignLeadToFirm: 'admin-user/assign-lead-to-firm',
    },
    roleManagement: {
      getRoleManagementList: 'admin/role/list',
      addEditRole: 'admin/role/save',
      ActiveInActiveRole: 'admin/role/active-inactive',
      getmenuList: 'admin/role/get-permission'
    },
    AccessManagement: {
      getAccessMenuList: 'admin/role/get-permission',
      SaveMenuPermissions: 'admin/role/SaveMenuPermission',
      getAccessMenuListView: 'admin/role/get-permission-view',
    },
    creditAdjustment: {
      save: 'credit-adjustment/save',
      topUpAdjustment: 'credit-adjustment/top-up',
      getCustomerListForCreditRefund: 'credit-adjustment/getCustomerListForCreditRefund',
      saveCreditRefundAdjustment: 'credit-adjustment/save-refund',
      getCustomerListForSendLink: 'credit-adjustment/getCustomerListForSendLink',
      getCustomerListForCreateProfile: 'credit-adjustment/getCustomerListForCreateProfile',
      getFirmReferralList: 'credit-adjustment/getFirmList',
      getFirmGiveawayList: 'credit-adjustment/firm-pending-giveaway-list',
      saveFirmReferralAdjustment: 'credit-adjustment/save-firm-referral'
    },
    AdminReferrals: {
      getAdminReferralsList: 'firmRegistration/admin-referrals-list',
      getAdminReferralColumnData:
        'firmRegistration/get-admin-referrals-columns',
      exportAdminReferrals: 'firmRegistration/export-admin-referrals',
      updateAdminReferralId: 'firmRegistration/update-admin-referral/{LeadId}/{Email}',
      getFirmSubscriptionSummary: 'firmRegistration/get-firm-subscription-summary'
    },

    headerContentManage: {
      saveHeaderContent: 'header-content/AddUpdateFirmHeader',
      getFirmHeaderContent: 'header-content/GetFirmHeaderContent',
      getAgentDemoContent: 'header-content/get-agent-demo-content',
      saveAgentDemoContent: 'header-content/save-agent-demo-content',
      savePartnerHeaderContent: 'header-content/AddUpdatePartnerHeader',
      getPartnerHeaderContent: 'header-content/GetPartnerHeaderContent'
    },
    CustomerContentManagement: {
      saveCustomerContentManagement: 'header-content/save-customer-content',
      getCustomerContentManagementList: 'header-content/get-customer-content-by-id/{RegisterType}',
    },
    SweetSpotContentManagement: {
      saveSweetSpotContentManagement: 'header-content/save-sweet-spot-content',
      getSweetSpotContentManagementList: 'header-content/get-sweet-spot-content',
      getSweetSpotHeadersubheaderManagementList: 'header-content/get-sweet-spot-content-headersubheader/{menuId}',

    },
    CustomerTermsCondition: {
      getCustomerTermsCondition: 'admin/termsAndConditions/get-customer-terms-condition',
      saveCustomerTermsCondition: 'admin/termsAndConditions/save-customer-terms-condition',
      deleteCustomerTermsCondition: 'admin/termsAndConditions/delete-customer-terms-condition/{CustomerTermsConditionIds}'
    },
    heardAboutUsMaster: {
      saveHeardAboutUsMaster: "admin/heard-about-us/save",
      getHeardAboutUsMasterList: "admin/heard-about-us/GetList",
      getListForSignQuestion: "admin/heard-about-us/GetListForSignQuestion"
    },
    partner: {
      save: 'partner/save',
      getPartnerById: 'partner/get-partner-details-by-id',
      getPartnerByUserId: 'partner/get-partner-details-by-userid',
      uploadDocuments: 'partner/upload-documents',
      uploadBannerProfile: 'partner/upload-banner-profile',
      getUploadedDocuments: 'partner/get-uploaded-documents/{PartnerId}',
      deleteDocument: 'partner/delete-document',
      getPartnerReferenceId: 'partner/get-partner-reference-id',
      checkApproval: 'partner/check-approval',
      getAdminPartnerList: 'partner/get-admin-partner-list',
      approveReject: 'partner/approve-reject',
      sendReferral: 'partner/send-referral',
      getReferralList: 'partner/get-referral-list',
      getRewardHistory: 'partner/get-reward-history/{PartnerId}',
      allowAddCustomer: 'partner/allow-add-customer',
      allowAddFirm: 'partner/allow-add-firm',
      addCustomerReferral: 'partner/add-customer-referral',
      getCustomerReferralList: 'partner/customer-referral-list',
      getCustomerReferralById: 'partner/customer-referral/{id}',
      resendRegistrationEmail: 'partner/resend-registration-email',
      getWalletDashboard: 'partner/wallet-dashboard',
      redeemReward: 'partner/payout/redeem',
      getWithdrawalHistory: 'partner/payout/history',
      validateRegistrationToken: 'partner/validate-registration-token',
      completeCustomerRegistration: 'partner/complete-customer-registration',
      addFirmReferral: 'partner/add-firm-referral',
      getFirmReferralList: 'partner/firm-referral-list',
      getFirmReferralById: 'partner/firm-referral/{id}',
      resendFirmRegistrationEmail: 'partner/resend-firm-registration-email',
      validateReferralCode: 'partner/validate-referral-code/',
      getReferralPrefill: 'partner/referral-prefill',
    },
    KPIChart: {
      getTotalUserList: 'kpichart/total-customer-agent-firm-chart',
      getcumulativeDisputeList: 'kpichart/dispute-chart',
      getGrossRevenueFromLeadList: 'kpichart/gross-revenue-chart',
      getGrossPointExpensesFromExclusiveSharedLeadList: 'kpichart/gross-point-expenses-exclusive-shared-chart',
      getCashPaymentForAdjustment: 'kpichart/cash-payments-for-adjustment',
      getCashPaymentForTopUp: 'kpichart/cash-payments-for-topUp',
      getCashPaymentsForSubscription: 'kpichart/cash-payments-for-subscription',
      getFirmCancelServiceSubscription: 'kpichart/firm-cancel-service-subscription',
      getSourceOfLeadGenerationList: 'kpichart/source-of-lead-generation',
      getSourceOfLeadGenerationRevenueList: 'kpichart/source-of-lead-generation-revenue',
      getPaymentForIncentivesAndReferrals: 'kpichart/payment-incentives-referrals',
      getSourceOfLeadGenerationByFirmAgentList: 'kpichart/firm-agent-source-of-lead-generation',
      getSourceOfLeadGenerationRevenueByFirmAgentList: 'kpichart/firm-agent-source-of-lead-generation-revenue',
      getTotalUserByFirmAgentList: 'kpichart/total-users-by-firm-agent-chart',
    },
    StateConfiguration: {
      viewStateConfiguration: 'common/StateConfigration/view-list',
      updateStateConfiguration: 'common/StateConfigration/update',
      sendStateActivationNotifications: 'admin/state-activation-notification/send-notifications',
    },
    leadValidation: {
      leadValidationList: 'admin/LeadValidation/list',
      manageStaffList: 'admin/LeadValidation/manage-staff-list',
      avaliableStaff: 'admin/LeadValidation/avaliable-staff-list',
      assignStaff: 'admin/LeadValidation/assign-staff',
      unassignStaff: 'admin/LeadValidation/unassign-staff',
      getPaymentConfig: 'admin/LeadValidation/get-payment-config',
      savePaymentConfig: 'admin/LeadValidation/save-payment-config',
    },
     lvSubscription: {
      getCheckoutModal:        'lv-subscription/checkout-modal',
      calculateProration:      'lv-subscription/calculate-proration',
       processPayment:          'lv-subscription/process-payment',
      createSubscriptionCheckout:  'lv-subscription/create-subscription-checkout',
       processPaymentIntent: 'lv-subscription/process-payment-intent',
       verifySession: 'lv-subscription/verify-session',
       updateSubscription: 'lv-subscription/update-subscription',

        cancelSubscription: 'lv-subscription/cancel-subscription',
        updateLeadValidation: 'lv-subscription/update-lead-validation',
        getPaymentDetails: 'lv-subscription/get-payment-details',
        viewReceiptPdf: 'lv-subscription/view-receipt-pdf',
        TopUpCreatePaymentIntent: 'lv-subscription/topup-create-payment-intent',
        TopUpCancelPaymentIntent: 'lv-subscription/topup-cancel-payment-intent',
        TopUpConfirmPayment: 'lv-subscription/topup-confirm-payment'
    },
    subscriptionCheckout: {
      getModalData:           'subscription-checkout/modal-data',
      calculatePricing:       'subscription-checkout/calculate-pricing',
      createPaymentIntent:    'subscription-checkout/create-payment-intent',
      confirmPayment:         'subscription-checkout/confirm-payment',
      cancelService:          'subscription-checkout/cancel-service',
      cancelSubscription:     'subscription-checkout/cancel-subscription',
      updateStaffCount:       'subscription-checkout/update-staff-count'
    },
    senemDigital: {
      getBuyersList: 'admin/senemDigital/buyers',
      getAddOnTypes: 'admin/senemDigital/addOnTypes',
      getFirmDetails: 'admin/senemDigital/firmDetails',
      getFirmInvoices: 'admin/senemDigital/invoices',
      getManageAgencyDetails: 'admin/senemDigital/manageAgencyDetails',
      saveAgencyDetails: 'admin/senemDigital/saveAgencyDetails',
    },
    socialMediaLeads: {
      getList: 'firm/social-media-leads/list',
      getById: 'firm/social-media-leads/get/{id}',
      getRegistrationLink: 'firm/social-media-leads/registration-link',
      submitQuote: 'firm/social-media-leads/submit-quote',
      getQuote: 'firm/social-media-leads/get-quote/{socialMediaLeadId}',
      completeRegistration: 'firm/social-media-leads/complete-registration',
      updateEmail: 'firm/social-media-leads/update-email',
    },
    socialMediaRegistration: {
      getAgencyByCode: 'common/social-media-registration/agency/{code}',
      signUp: 'common/social-media-registration/signup',
      verifyOtp: 'common/social-media-registration/verify-otp',
      verifyOtpAndRegister: 'common/social-media-registration/verify-otp-and-register',
      signupAndRegister: 'common/social-media-registration/signup-and-register',
      checkExistingCustomer: 'common/social-media-registration/check-existing-customer',
      resendOtp: 'common/social-media-registration/resend-otp',
    }

  };
  
}

